module.exports = __webpack_public_path__ + "assets/img/vtuber-ads6.3f98e33a.png";